module.exports = "<div class=\"zizHeader logo text-center\">\r\n<img src=\"assets/img/ziz.png\" class=\"logo-img\" (click)=\"redirectpage()\">\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/common/adv-header-before-login.component.html
// module id = 1072
// module chunks = 31